.main {
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
}
